<glxy-badge class="ai-badge">
  <mat-icon svgIcon="galaxy-ai-icon-monochrome" aria-hidden="false" aria-label="AI" />
  <span>AI</span>
</glxy-badge>
